
const digest = '5df6194496665f4ba114ad5d5891bbd1a3571d7e736c36fd349a34f9e9795d1f';
const classes = {"wrapper":"_wrapper_wis2j_1","date":"_date_wis2j_12","content":"_content_wis2j_23","items":"_items_wis2j_32","item":"_item_wis2j_32","label":"_label_wis2j_43","controls":"_controls_wis2j_46","invalid":"_invalid_wis2j_58"};
const css = `._wrapper_wis2j_1 {
  font-family: Rubik, sans-serif;
  display: flex;
  flex-direction: row;
  width: 100%;
  border: 1px solid #eaedf3;
  border-top: 0;
}
._wrapper_wis2j_1:first-of-type {
  border-top: 1px solid #eaedf3;
}
._wrapper_wis2j_1 ._date_wis2j_12 {
  display: flex;
  align-items: center;
  border-right: 1px solid #eaedf3;
  padding: 24px;
  gap: 16px;
  min-width: 200px;
  max-width: 200px;
  font-size: 14px;
  color: #000000;
}
._wrapper_wis2j_1 ._content_wis2j_23 {
  font-size: 14px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 24px;
  justify-content: center;
}
._wrapper_wis2j_1 ._content_wis2j_23 ._items_wis2j_32 {
  display: flex;
  flex-direction: row;
  gap: 10px;
}
._wrapper_wis2j_1 ._content_wis2j_23 ._items_wis2j_32 ._item_wis2j_32 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
}
._wrapper_wis2j_1 ._content_wis2j_23 ._items_wis2j_32 ._item_wis2j_32 ._label_wis2j_43 {
  color: #9ea0a5;
}
._wrapper_wis2j_1 ._controls_wis2j_46 {
  border-left: 1px solid #eaedf3;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px;
  gap: 16px;
  min-width: 200px;
  max-width: 200px;
}

._invalid_wis2j_58 {
  background-color: #f8dadb;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  